import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as React from 'react';
import { ChakraProvider } from '@chakra-ui/react';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
